//this file will export all the helper functions/classes
//utils file has all common/most used functions
import Utils from "./utils";
import ParameterHandler from "./ParameterHandler";
import CustomDataLoader from "./CustomDataLoader";
import PopupContext from "./PopupContext";
import Tabs from "./custom-components/tabs";
import DomElementPrinter from "./domElementPrinter";
export default { Utils, ParameterHandler, DomElementPrinter, CustomDataLoader };
//export any re-usable react component separately

export { PopupContext, Tabs, ParameterHandler, Utils, DomElementPrinter };
